import ApiHandler from './ApiHandler';

export default {
    getAll: () => ApiHandler.get(`/countries`)
};
